import { useMemo } from "react";

import { PollingIntervalGroups } from "apollo/constants";
import usePolledQuery from "apollo/usePolledQuery";
import useMakeFiltersData from "components/Filters/useMakeFiltersData";

import { SPACELIFT_VCS_REPOS_SUGGESTIONS_DICTIONARY } from "./constants";
import { SEARCH_SPACELIFT_VCS_REPOS_SUGGESTIONS } from "./gql";
import useSpaceliftVcsReposFiltersVariables from "./useFiltersVariables";

const useSearchSpaceliftVcsReposSuggestions = () => {
  const { fullTextSearch, predicates, filterVariablesLoaded } =
    useSpaceliftVcsReposFiltersVariables();

  const { data, error, loading, previousData } = usePolledQuery(
    SEARCH_SPACELIFT_VCS_REPOS_SUGGESTIONS,
    {
      variables: {
        input: {
          fullTextSearch,
          predicates,
          fields: null,
        },
      },
      skip: !filterVariablesLoaded,
      pollingGroup: PollingIntervalGroups.Lists,
    }
  );

  const cachedSuggestions = useMemo(() => {
    return (
      data?.searchReposSuggestions?.fields || previousData?.searchReposSuggestions?.fields || []
    );
  }, [data, previousData]);

  const filteredCount = useMemo(() => {
    return (
      data?.searchReposSuggestions?.filteredCount ||
      previousData?.searchReposSuggestions?.filteredCount ||
      0
    );
  }, [data, previousData]);

  const { filters, filterOptionsMap } = useMakeFiltersData({
    suggestions: cachedSuggestions,
    dictionary: SPACELIFT_VCS_REPOS_SUGGESTIONS_DICTIONARY,
  });

  return {
    filters,
    filterOptionsMap,
    filteredCount,
    loading: loading || !filterVariablesLoaded,
    error,
  };
};

export default useSearchSpaceliftVcsReposSuggestions;
